import React from 'react';
import './BulkGrid.scss';
import { Button, DataGrid } from 'devextreme-react';
import { Column } from 'devextreme-react/cjs/data-grid';
import notify from 'devextreme/ui/notify';
import GlobalParams from '../../helpers/GlobalParams';

const BulkGrid = ({ BulksData }) => {

  console.log(BulksData);
  const bulkColumns = [
    { dataField: 'scheme_id', visible: false },
    {
      dataField: 'policy_number', caption: 'Scheme Number',
      groupIndex: 0
    },
    {
      dataField: 'EndorsementType',
      groupIndex: 1
    },
    { dataField: 'Member', visible: false },
    { dataField: 'MemberName', caption: 'Name' },
    { dataField: 'MemberAge', caption: 'Age', visible: false },
    { dataField: 'MemberNo', caption: 'Staff No', visible: false },
    //bulk_upload, Status, file_name, file_url
    { dataField: 'bulk_upload', dataType: 'boolean' },
    { dataField: 'file_name' },
    { dataField: 'file_url', visible: false },
    { dataField: 'EffectiveDate', dataType: 'date' },
    { dataField: 'Status', groupIndex: 2 },
    { dataField: 'MemberSalary', caption: 'Salary', visible: false },
    { dataField: 'IdType', visible: false },
    { dataField: 'IdNumber', visible: false },
    { dataField: 'HasDependants', dataType: 'boolean', visible: false },
    { dataField: 'EndorsementRequest', visible: false }
  ];



  return (
    <div>
      <h5 className="card-title" style={{ color: '#2E86C1', fontWeight: 'bold' }}>Bulk Uploads...</h5>
      <DataGrid
        dataSource={BulksData}
        wordWrapEnabled={true}
        //columns={bulkColumns}
        grouping={{ autoExpandAll: false }}
        summary={{
          groupItems: [
            {
              column: 'Description',
              summaryType: 'count',
              showInGroupFooter: false
            }
          ]
        }}
        onRowClick={(e) => {
          notify("download is coming soon", 5000);
        }}
      >
        <Column dataField="scheme_id" visible={false}></Column>
        <Column dataField="policy_number" caption='Scheme Number' groupIndex={0} ></Column>
        <Column dataField="EndorsementType" groupIndex={1}></Column>
        <Column dataField="Member" visible={false}></Column>
        <Column dataField="MemberName"></Column>
        <Column dataField="MemberAge" caption='Age' visible={false}></Column>
        <Column dataField="MemberNo" caption='Staff No' visible={false}></Column>

        <Column dataField="bulk_upload" dataType='boolean'></Column>
        <Column dataField="file_name"></Column>
        <Column dataField="file_url" visible={false}></Column>
        <Column dataField="CreatedOn" caption="Effective Date" dataType='date' ></Column>
        <Column dataField="Status"></Column>

        <Column dataField="MemberSalary" caption='Salary' visible={false} ></Column>
        <Column dataField="IdType" visible={false}></Column>
        <Column dataField="IdNumber" visible={false}></Column>
        <Column dataField="HasDependants" dataType='boolean' visible={false}></Column>
        <Column dataField="EndorsementRequest" visible={false}></Column>
        <Column visible={false} cellRender={(cellInfo) => {
          return (
            <div>
              <Button
                text=""
                type='danger'
                icon='download'
                onClick={
                  () => {
                    //download the file
                    let filename = cellInfo.data.file_name;
                    console.log(filename);
                    const anchor = document.createElement('a');
                    anchor.href = GlobalParams.SupportFileUrl + filename;
                    anchor.download = filename; // Set the filename for download
                    anchor.click();
                  }
                }
              />
            </div>
          );
        }}>
        </Column>
      </DataGrid>
    </div>
  );
};

export default BulkGrid;
